export interface QueryOptions {
  coordinates: [number, number];
  projection: string;
  resolution?: number;
}
